import { render, staticRenderFns } from "./ScreensView.vue?vue&type=template&id=308392ce&"
import script from "./ScreensView.vue?vue&type=script&lang=js&"
export * from "./ScreensView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports